import { render, staticRenderFns } from "./CustomerSapiaClub.vue?vue&type=template&id=c326aaee&scoped=true&"
import script from "./CustomerSapiaClub.vue?vue&type=script&lang=js&"
export * from "./CustomerSapiaClub.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSapiaClub.vue?vue&type=style&index=0&id=c326aaee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c326aaee",
  null
  
)

export default component.exports